import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-delete-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
  standalone: false,
})
// tslint:disable-next-line:component-class-suffix
export class ConfirmDialog {
  public title: string;
  public message: string;
  public confirmText: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    private sanitizer: DomSanitizer
  ) {
    this.sanitizer.bypassSecurityTrustHtml(this.message);
  }
}
